import React from 'react';
import CrudManager from '@/components/admin/CrudManager';

const AdminFAQs = () => (
  <CrudManager
    title="FAQs"
    subtitle="Frequently asked questions shown on the homepage."
    endpoint="/admin/faqs"
    idField="faq_id"
    columns={[
      { key: 'question', label: 'Question' },
      { key: 'category', label: 'Category' },
    ]}
    initial={{ question: '', answer: '', category: 'general' }}
    fields={[
      { key: 'question', label: 'Question', required: true },
      { key: 'answer', label: 'Answer', type: 'textarea', rows: 4, required: true },
      { key: 'category', label: 'Category' },
    ]}
  />
);
export default AdminFAQs;
